let xhrCacheInstance;

export const setXhrCache = function (instance) {
  xhrCacheInstance = instance;
};

export const getXhrCache = function () {
  return xhrCacheInstance;
};
